"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPayoutsStatistics = exports.GET_PAYOUTS = void 0;
const axios_1 = __importDefault(require("axios"));
const ethers_1 = require("ethers");
const utils_1 = require("ethers/lib/utils");
const config_1 = require("../config");
exports.GET_PAYOUTS = `
  query getClaims {
    claims {
			claim
			createdAt
			approvedAt
			dismissedAt
			hackerReward
			hackerVestedReward
			committeeReward
			governanceHatReward
			vault {
				name
				version
				id
				stakingToken
				stakingTokenSymbol
				stakingTokenDecimals
				descriptionHash
			}
		}
  }
`;
const getAllPayoutsStatistics = async () => {
    var _a;
    const subgraphsRequests = Object.values(config_1.ChainsConfig)
        .filter((chain) => !chain.chain.testnet)
        .map((chain) => {
        return axios_1.default.post(chain.subgraph, JSON.stringify({
            query: exports.GET_PAYOUTS,
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
    });
    const subgraphsResponses = await Promise.all(subgraphsRequests);
    const subgraphsData = subgraphsResponses
        .map((res) => res.data.data.claims)
        .flat()
        .filter((claim) => claim.approvedAt);
    console.log(subgraphsResponses.map((res) => res.data.data.claims));
    // Get description for each vault
    for (const claimData of subgraphsData) {
        const res = await axios_1.default.get(`https://ipfs2.hats.finance/ipfs/${claimData.vault.descriptionHash}`);
        const descriptionData = res.data;
        claimData.vault.description = descriptionData;
    }
    let payoutsData = [];
    // Fill information
    for (const claimData of subgraphsData) {
        const immediate = ethers_1.BigNumber.from(claimData.hackerReward);
        const vested = ethers_1.BigNumber.from(claimData.hackerVestedReward);
        const committee = ethers_1.BigNumber.from(claimData.committeeReward);
        const governance = ethers_1.BigNumber.from(claimData.governanceHatReward);
        const total = immediate.add(vested).add(committee).add(governance);
        payoutsData.push({
            approvedAt: new Date(claimData.approvedAt * 1000),
            vaultName: ((_a = claimData.vault.description["project-metadata"]) !== null && _a !== void 0 ? _a : claimData.vault.description["Project-metadata"]).name,
            vaultId: claimData.vault.id,
            vaultVersion: claimData.vault.version,
            vaultTokenSymbol: claimData.vault.stakingTokenSymbol,
            vaultTokenAddress: claimData.vault.stakingToken,
            totalPaid: Number((0, utils_1.formatUnits)(total, claimData.vault.stakingTokenDecimals)),
            immediatePayment: Number((0, utils_1.formatUnits)(immediate, claimData.vault.stakingTokenDecimals)),
            vestedPayment: Number((0, utils_1.formatUnits)(vested, claimData.vault.stakingTokenDecimals)),
            committeePayment: Number((0, utils_1.formatUnits)(committee, claimData.vault.stakingTokenDecimals)),
            governancePayment: Number((0, utils_1.formatUnits)(governance, claimData.vault.stakingTokenDecimals)),
        });
    }
    payoutsData.sort((a, b) => a.approvedAt.getTime() - b.approvedAt.getTime());
    payoutsData = payoutsData.map((payout) => (Object.assign(Object.assign({}, payout), { approvedAt: payout.approvedAt.toLocaleDateString() })));
    return payoutsData;
};
exports.getAllPayoutsStatistics = getAllPayoutsStatistics;
